import React, { useEffect, useState } from "react";
import withRouter from "components/Common/withRouter";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Input,
  Button,
  Table,
  Badge,
  Spinner,
  Alert,
  CardHeader
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from 'axios';

// API Base URL
const API_URL = "https://subseaapi.stechomeyazilim.info";

const NewsletterSender = props => {
  document.title = "E-Bülten Gönder | SUBSEA ADMIN";

  // --- STATE YÖNETİMİ ---
  const [listings, setListings] = useState([]);      // İlanlar
  const [resources, setResources] = useState([]);    // Blog/Kaynaklar
  const [subscribers, setSubscribers] = useState([]); // Aboneler

  // Seçilenler
  const [selectedListings, setSelectedListings] = useState([]);
  const [selectedResources, setSelectedResources] = useState([]);
  const [selectedSubscriberIds, setSelectedSubscriberIds] = useState([]);
  
  const [sendToAll, setSendToAll] = useState(true); // Tümüne gönder modu

  // Yükleme Durumları
  const [loading, setLoading] = useState({
    listings: true,
    resources: true,
    subscribers: true
  });
  
  const [isSending, setIsSending] = useState(false);
  const [apiMessage, setApiMessage] = useState({ type: "", message: "" });

  // --- API ÇAĞRILARI ---
  useEffect(() => {
    fetchListings();
    fetchResources();
    fetchSubscribers();
  }, []);

  const fetchListings = async () => {
    try {
      const res = await axios.get(`${API_URL}/Listings?$select=ID,Title,PriceValue,PriceCurrency,Type&$orderby=CreatedAt desc&$top=50`);
      setListings(res.data.value || res.data);
    } catch (err) { console.error("İlanlar hatası:", err); } 
    finally { setLoading(prev => ({ ...prev, listings: false })); }
  };

  const fetchResources = async () => {
    try {
      const res = await axios.get(`${API_URL}/Resources?$select=ID,Title,PublishedAt,Summary&$orderby=PublishedAt desc&$top=20`);
      setResources(res.data.value || res.data);
    } catch (err) { console.error("Blog hatası:", err); } 
    finally { setLoading(prev => ({ ...prev, resources: false })); }
  };

  const fetchSubscribers = async () => {
    try {
      const res = await axios.get(`${API_URL}/NewsletterSubscriptions?$filter=IsConfirmed eq true&$select=ID,Email`);
      setSubscribers(res.data.value || res.data);
    } catch (err) { console.error("Abone hatası:", err); } 
    finally { setLoading(prev => ({ ...prev, subscribers: false })); }
  };

  // --- SEÇİM FONKSİYONLARI ---
  const toggleSelection = (id, list, setList) => {
    if (list.includes(id)) {
      setList(list.filter(item => item !== id));
    } else {
      setList([...list, id]);
    }
  };

  const toggleAllSubscribers = (e) => {
    if (e.target.checked) {
      setSelectedSubscriberIds(subscribers.map(s => s.ID));
    } else {
      setSelectedSubscriberIds([]);
    }
  };

  // --- FORMIK & GÖNDERİM ---
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      desc: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Bülten başlığı zorunludur."),
      desc: Yup.string().required("Bülten içeriği zorunludur."),
    }),
    onSubmit: async (values, { resetForm }) => {
      
      if (selectedListings.length === 0 && selectedResources.length === 0) {
        if (!window.confirm("Hiçbir ilan veya blog yazısı seçmediniz. Sadece metin gönderilsin mi?")) {
            return;
        }
      }

      if (!sendToAll && selectedSubscriberIds.length === 0) {
        setApiMessage({ type: "warning", message: "Lütfen en az bir alıcı seçiniz." });
        return;
      }

      setIsSending(true);
      setApiMessage({ type: "", message: "" });

      const payload = {
        Subject: values.title,
        BodyContent: values.desc,
        SendToAll: sendToAll,
        SelectedSubscriberIds: sendToAll ? [] : selectedSubscriberIds,
        SelectedListingIds: selectedListings,
        SelectedResourceIds: selectedResources
      };

      try {
        const url = `${API_URL}/NewsletterSubscriptions/SendNewsletter`;
        await axios.post(url, payload);
        
        setApiMessage({ type: "success", message: "Bülten başarıyla kuyruğa alındı ve gönderiliyor." });
        
        resetForm();
        setSelectedListings([]);
        setSelectedResources([]);
        setSelectedSubscriberIds([]);
        setSendToAll(true);
        
      } catch (error) {
        const errorMsg = error.response?.data?.error?.message || error.message;
        setApiMessage({ type: "danger", message: "Hata: " + errorMsg });
      } finally {
        setIsSending(false);
      }
    },
  });

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Pazarlama" breadcrumbItem="E-Bülten Oluşturucu" />

        {apiMessage.message && (
          <Alert color={apiMessage.type} toggle={() => setApiMessage({ type: "", message: "" })} className="mb-4">
            {apiMessage.message}
          </Alert>
        )}

        <Row>
          {/* --- KOLON 1: İÇERİK & ALICILAR --- */}
          <Col lg="4">
            <Card className="h-100">
              <CardHeader className="bg-transparent border-bottom">
                <h5 className="my-0 text-primary"><i className="bx bx-envelope me-2"></i>1. İçerik ve Alıcılar</h5>
              </CardHeader>
              <CardBody>
                <form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false; }}>
                  
                  <div className="mb-3">
                    <Label>Konu Başlığı</Label>
                    <Input
                      name="title"
                      placeholder="Örn: Haftanın Fırsatları"
                      value={validation.values.title}
                      onChange={validation.handleChange}
                      invalid={!!validation.errors.title && validation.touched.title}
                    />
                  </div>

                  <div className="mb-3">
                    <Label>Giriş Yazısı</Label>
                    <Input
                      type="textarea"
                      rows="6"
                      name="desc"
                      placeholder="Sayın üyemiz..."
                      value={validation.values.desc}
                      onChange={validation.handleChange}
                      invalid={!!validation.errors.desc && validation.touched.desc}
                    />
                  </div>

                  <hr className="my-4"/>

{/* --- KESİN ÇÖZÜM: Kapsayıcıya Tıklama Özelliği --- */}
<div 
  className="d-flex align-items-center mb-3 p-2 border rounded bg-light"
  onClick={() => setSendToAll(!sendToAll)} // Tıklamayı burada yakalıyoruz
  style={{ cursor: 'pointer', userSelect: 'none' }} // Fare imlecini el yapıyoruz
>
  <div className="form-check form-switch m-0" style={{ pointerEvents: 'none' }}> {/* İçerideki tıklamaları iptal et */}
    <input
      className="form-check-input"
      type="checkbox"
      role="switch"
      checked={sendToAll}
      readOnly // Sadece görüntü amaçlı, kontrol div'de
      style={{ width: '2.5em', height: '1.25em' }}
    />
  </div>
  <span className="fw-bold ms-3">
    Tümüne Gönder ({subscribers.length})
  </span>
</div>
{/* ------------------------------------------------ */}
{/* --------------------------------- */}
                  {/* --------------------------------- */}

                {/* Eğer Tümüne Gönder KAPALI ise Listeyi Göster */}
{!sendToAll && (
  <div className="border rounded bg-white" style={{ maxHeight: '300px', overflowY: 'auto' }}>
    
    {/* HEPSİNİ SEÇ SATIRI */}
    <div 
        className="d-flex align-items-center p-2 border-bottom bg-light sticky-top"
        onClick={(e) => {
            // "Hepsini Seç" mantığı
            if (selectedSubscriberIds.length === subscribers.length && subscribers.length > 0) {
                setSelectedSubscriberIds([]);
            } else {
                setSelectedSubscriberIds(subscribers.map(s => s.ID));
            }
        }}
        style={{ cursor: 'pointer', userSelect: 'none' }}
    >
        <div className="form-check m-0" style={{ pointerEvents: 'none' }}>
            <input 
                type="checkbox" 
                className="form-check-input"
                checked={selectedSubscriberIds.length === subscribers.length && subscribers.length > 0}
                readOnly
            />
        </div>
        <span className="fw-bold ms-2 small">Hepsini Seç</span>
    </div>

    {/* KULLANICI LİSTESİ */}
    {loading.subscribers ? (
        <div className="text-center p-3"><Spinner size="sm"/></div>
    ) : (
        subscribers.map(sub => {
            const isSelected = selectedSubscriberIds.includes(sub.ID);
            return (
                <div 
                    key={sub.ID} 
                    className="d-flex align-items-center p-2 border-bottom"
                    onClick={() => toggleSelection(sub.ID, selectedSubscriberIds, setSelectedSubscriberIds)}
                    style={{ 
                        cursor: 'pointer', 
                        userSelect: 'none',
                        backgroundColor: isSelected ? '#e6f7ff' : 'transparent' // Seçilince renk değişsin
                    }}
                >
                    <div className="form-check m-0" style={{ pointerEvents: 'none' }}>
                        <input 
                            type="checkbox" 
                            className="form-check-input" 
                            checked={isSelected}
                            readOnly // Kontrolü div'e bıraktık
                        />
                    </div>
                    <span className="ms-2 small text-truncate" style={{maxWidth: '250px'}}>
                        {sub.Email}
                    </span>
                </div>
            );
        })
    )}
  </div>
)}


                  <Button type="submit" color="success" className="w-100 mt-2" size="lg" disabled={isSending}>
                    {isSending ? <Spinner size="sm" /> : <><i className="bx bx-paper-plane me-1"></i> GÖNDER</>}
                  </Button>
                </form>
              </CardBody>
            </Card>
          </Col>

          {/* --- KOLON 2: İLAN SEÇİMİ --- */}
          <Col lg="4">
            <Card className="h-100">
              <CardHeader className="bg-transparent border-bottom d-flex justify-content-between align-items-center">
                <h5 className="my-0 text-info"><i className="bx bx-store me-2"></i>2. İlan Ekle ({selectedListings.length})</h5>
                <Button size="sm" color="light" onClick={fetchListings}><i className="bx bx-refresh"></i></Button>
              </CardHeader>
              <CardBody className="p-0">
                {loading.listings ? <div className="text-center p-5"><Spinner /></div> : (
                  <div style={{ maxHeight: '650px', overflowY: 'auto' }}>
                    <Table hover responsive className="align-middle mb-0">
                      <thead className="table-light sticky-top">
                        <tr>
                          <th width="40">#</th>
                          <th>Başlık</th>
                          <th>Fiyat</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listings.map(item => (
                          <tr 
                            key={item.ID} 
                            onClick={() => toggleSelection(item.ID, selectedListings, setSelectedListings)}
                            style={{ cursor: 'pointer', backgroundColor: selectedListings.includes(item.ID) ? '#e0f3ff' : 'transparent' }}
                          >
                            <td><Input type="checkbox" checked={selectedListings.includes(item.ID)} onChange={()=>{}} /></td>
                            <td>
                              <div className="text-truncate fw-bold" style={{maxWidth: '150px'}} title={item.Title}>{item.Title}</div>
                              <Badge color="info" pill className="font-size-10">{item.Type}</Badge>
                            </td>
                            <td className="small">{item.PriceValue} {item.PriceCurrency}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          {/* --- KOLON 3: BLOG/KAYNAK SEÇİMİ --- */}
          <Col lg="4">
            <Card className="h-100">
              <CardHeader className="bg-transparent border-bottom d-flex justify-content-between align-items-center">
                <h5 className="my-0 text-warning"><i className="bx bx-news me-2"></i>3. Blog Ekle ({selectedResources.length})</h5>
                <Button size="sm" color="light" onClick={fetchResources}><i className="bx bx-refresh"></i></Button>
              </CardHeader>
              <CardBody className="p-0">
                {loading.resources ? <div className="text-center p-5"><Spinner /></div> : (
                  <div style={{ maxHeight: '650px', overflowY: 'auto' }}>
                    <Table hover responsive className="align-middle mb-0">
                      <thead className="table-light sticky-top">
                        <tr>
                          <th width="40">#</th>
                          <th>Blog Başlığı</th>
                          <th>Tarih</th>
                        </tr>
                      </thead>
                      <tbody>
                        {resources.length === 0 && <tr><td colSpan="3" className="text-center p-3 text-muted">Kayıt bulunamadı.</td></tr>}
                        {resources.map(item => (
                          <tr 
                            key={item.ID} 
                            onClick={() => toggleSelection(item.ID, selectedResources, setSelectedResources)}
                            style={{ cursor: 'pointer', backgroundColor: selectedResources.includes(item.ID) ? '#fff3cd' : 'transparent' }}
                          >
                            <td><Input type="checkbox" checked={selectedResources.includes(item.ID)} onChange={()=>{}} /></td>
                            <td>
                              <div className="fw-bold text-truncate" style={{maxWidth: '180px'}} title={item.Title}>{item.Title}</div>
                            </td>
                            <td>
                                <small className="text-muted">
                                    {item.PublishedAt ? new Date(item.PublishedAt).toLocaleDateString("tr-TR") : "-"}
                                </small>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

        </Row>
      </Container>
    </div>
  );
};

export default withRouter(NewsletterSender);